import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { DIALOG_MESSAGE as CORE_DIALOG } from '~/core/constants';
import townApi from '~/core/components/TownSelect/api';
import FullscreenTownSelect from '~/core/components/FullscreenTownSelect/FullscreenTownSelect.vue';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useTownModalStore from '~/stores/useTownModalStore';
import useProfileStore from '~/stores/useProfileStore';
export default defineComponent({
  name: 'TownSelect',
  components: {
    FullscreenTownSelect: FullscreenTownSelect
  },
  setup: function setup() {
    var profileStore = useProfileStore();
    var $dialog = useMainDialogStore();
    var $snackbar = useMainSnackbarStore();
    var townModalStore = useTownModalStore();
    var isPending = ref(false);
    var isActive = computed({
      get: function get() {
        return townModalStore.isActive;
      },
      set: function set(val) {
        if (townModalStore.isActive === val) {
          return;
        }
        return val ? townModalStore.open() : townModalStore.close();
      }
    });
    var town = computed({
      get: function get() {
        return profileStore.composedTownObject;
      },
      set: function set(val) {
        return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!isPending.value) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                isPending.value = true;
                _context.next = 6;
                return townApi.patch({
                  town: val.id,
                  townConfirmed: true
                });
              case 6:
                profileStore.setTown({
                  town: val.name,
                  townKey: val.key,
                  townId: val.id
                });
                profileStore.townConfirmed = true;
                if (!townModalStore.afterTownSelectHandler) {
                  _context.next = 12;
                  break;
                }
                _context.next = 11;
                return townModalStore.afterTownSelectHandler(val.key);
              case 11:
                return _context.abrupt("return");
              case 12:
                isActive.value = false;
                $snackbar.open({
                  text: "\u0412\u0430\u0448 \u0433\u043E\u0440\u043E\u0434 ".concat(val.name),
                  cancelText: 'изменить',
                  cancelHandler: function cancelHandler() {
                    isActive.value = true;
                  }
                });
                _context.next = 19;
                break;
              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](2);
                $dialog.open(_objectSpread({}, CORE_DIALOG.GLOBAL_ERROR));
              case 19:
                _context.prev = 19;
                isPending.value = false;
                return _context.finish(19);
              case 22:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 16, 19, 22]]);
        }))();
      }
    });
    return {
      isActive: isActive,
      town: town
    };
  }
});